import * as React from 'react';
import { IconProps } from '../types';

const IcBreak = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <path
      fill={props?.fill ?? '#232F3E'}
      d="M12.5 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-18.571a8.571 8.571 0 1 0 0 17.142 8.571 8.571 0 0 0 0-17.142Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m15.779 16.286-3.993-3.993V5.57h1.428V11.7l3.572 3.579-1.007 1.007Z"
    />
  </svg>
);

export default IcBreak;